// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"03e38b6b16d8e7751d3c","404":"ec533a4756fb5c7b8cdf","406":"134948812ced6d7f76a9"}[chunkId] + ".css";
};